

















import {Component, Vue} from 'vue-property-decorator';
import {
  Getter,
} from 'vuex-class';
import Snackbar from '@/modules/common/snackbar/_components/Snackbar.vue';
import LoaderFullscreen from '@/modules/common/loader/_components/LoaderFullscreen.vue';

@Component({
  components: {
    Snackbar,
    LoaderFullscreen,
  },
})
export default class App extends Vue {
  @Getter('common/loader/loadingNav') private loadingNav!: boolean;
}
